import { formatInteractionDateTime } from "../../../utils/dateUtils";
export const formatDateTime = (dateTimeString) => {
    return formatInteractionDateTime(dateTimeString);
};
export const formatCallFlowForDisplay = (callFlow) => {
    if (!callFlow)
        return ["No call flow data"];
    const parts = callFlow
        .split(/[;,]/)
        .map((part) => part.trim())
        .filter((part) => part.length > 0);
    return parts.length > 0 ? parts : ["No call flow data"];
};
export const getCallOutcome = (callFlow) => {
    if (!callFlow)
        return [];
    const parts = formatCallFlowForDisplay(callFlow);
    return parts.slice(-2);
};
export const getRecommendations = (callFlow) => {
    if (!callFlow)
        return [];
    const recommendations = [];
    const callFlowLower = callFlow.toLowerCase();
    if (callFlowLower.includes("no coverage")) {
        recommendations.push("No Schedule Coverage");
    }
    if (callFlowLower.includes("looking up schedule default")) {
        recommendations.push("Scheduling infinite loop");
    }
    return recommendations;
};
export const getActionColor = (action) => {
    const actionColors = {
        Error: "#e83e8c",
        Cancel: "#ff9e18",
        Complete: "#28a745",
        Timeout: "#fd7e14",
        HangUp: "#6f42c1",
        Disconnect: "#dc3545",
        Disconnected: "#6c757d",
        AgentText: "#374B94",
        Email: "#17a2b8",
        VoiceMessage: "#20c997",
        BlindTransfer: "#00abc8",
        ControlledTransfer: "#28a745",
        HandoffTransfer: "#ffc107",
    };
    return actionColors[action] || "#6c757d";
};
export const getEnvConfig = () => {
    if (typeof window !== "undefined") {
        return window.PSCONFIG || {};
    }
    return {};
};
//# sourceMappingURL=networkErrorsUtils.js.map